import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { ArrowRight, ChatCircle, VideoCamera, Users } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const Landing = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center font-mono text-sm">LOADING…</div>;
  if (user) return <Navigate to="/app" replace />;

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-paper text-ink">
      {/* Top bar */}
      <header className="border-b border-line">
        <div className="px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_omni-platform-20/artifacts/o5vuayu0_handy%20buzz%20%281%29.png"
              alt="Handy Buzzer"
              className="w-10 h-10 object-contain mix-blend-multiply"
            />
            <span className="font-heading font-black text-xl tracking-tight">HANDY BUZZER</span>
            <span className="label-tag ml-3 hidden sm:inline">// 01 — SUPER-APP</span>
          </div>
          <button data-testid="login-btn" onClick={handleLogin} className="btn-primary">
            SIGN IN <ArrowRight size={14} weight="bold" className="inline ml-2" />
          </button>
        </div>
      </header>

      {/* Hero */}
      <section className="border-b border-line">
        <div className="grid grid-cols-12 gap-0">
          <div className="col-span-12 lg:col-span-8 border-r border-line p-8 sm:p-16">
            <div className="label-tag mb-8">[ FILE — 001 / MANIFEST ]</div>
            <h1 className="font-heading font-black text-5xl sm:text-7xl lg:text-8xl leading-[0.9] tracking-tighter">
              CHAT.<br />
              <span className="text-signal-red">NETWORK.</span><br />
              MEETINGS.<br />
              <span className="italic font-light">one super-app.</span>
            </h1>
            <p className="mt-10 max-w-xl text-sm sm:text-base text-ink-2 leading-relaxed">
              The unified surface where conversations, careers, and calls collide — engineered with brutal clarity. No noise. No clutter. Just the signal.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <button data-testid="hero-cta" onClick={handleLogin} className="btn-primary">
                LAUNCH HANDY BUZZER
              </button>
              <a href="#features" className="btn-secondary inline-flex items-center">EXPLORE THE STACK</a>
            </div>
          </div>
          <aside className="col-span-12 lg:col-span-4 p-8 sm:p-10 bg-paper-tint">
            <div className="label-tag mb-6">REAL-TIME · v2026.02</div>
            <div className="space-y-6">
              <div className="border-b border-line pb-4">
                <div className="text-3xl font-heading font-black">3 IN 1</div>
                <div className="text-xs text-ink-2 mt-1">Chat + Network + Meet</div>
              </div>
              <div className="border-b border-line pb-4">
                <div className="text-3xl font-heading font-black">WSS://</div>
                <div className="text-xs text-ink-2 mt-1">WebSocket-powered chat</div>
              </div>
              <div>
                <div className="text-3xl font-heading font-black">VIDEO</div>
                <div className="text-xs text-ink-2 mt-1">HD calls, screen share, chat</div>
              </div>
            </div>
          </aside>
        </div>
      </section>

      {/* Features bento */}
      <section id="features" className="border-b border-line">
        <div className="grid grid-cols-12 gap-0">
          <div className="col-span-12 md:col-span-4 border-r border-line p-10">
            <ChatCircle size={36} weight="duotone" />
            <h3 className="font-heading font-bold text-2xl mt-6">REAL-TIME CHAT</h3>
            <p className="text-sm text-ink-2 mt-3 leading-relaxed">Instant 1-on-1 conversations. Push-style delivery. Online presence by socket.</p>
            <div className="label-tag mt-8">// MODULE A</div>
          </div>
          <div className="col-span-12 md:col-span-4 border-r border-line p-10 bg-ink text-white">
            <Users size={36} weight="duotone" />
            <h3 className="font-heading font-bold text-2xl mt-6">PROFESSIONAL GRAPH</h3>
            <p className="text-sm mt-3 leading-relaxed opacity-80">Profiles, feed, skills, connections. Your career, indexed.</p>
            <div className="label-tag mt-8 text-paper-tint">// MODULE B</div>
          </div>
          <div className="col-span-12 md:col-span-4 p-10">
            <VideoCamera size={36} weight="duotone" />
            <h3 className="font-heading font-bold text-2xl mt-6">VIDEO MEETINGS</h3>
            <p className="text-sm text-ink-2 mt-3 leading-relaxed">Corporate meetings, instant rooms & scheduled calls. Share a link and go live.</p>
            <div className="label-tag mt-8">// MODULE C</div>
          </div>
        </div>
      </section>

      <footer className="px-6 py-6 flex items-center justify-between text-xs text-ink-3">
        <span>© 2026 HANDY BUZZER · SWISS BRUTALISM EDITION</span>
        <span>BUILT ON E1</span>
      </footer>
    </div>
  );
};

export default Landing;
